<form class="profile" (submit)="onSave($event)" data-testid="profile-container">
  <section class="profile-section" data-testid="profile-card-personal">
    <app-user-picture></app-user-picture>

    <dx-form
      id="form"
      class="mt-3"
      [formData]="profile_data"
      [readOnly]="false"
      [showColonAfterLabel]="false"
      [showValidationSummary]="false"
      validationGroup="customerData"
      labelMode="floating"
      [colCount]="2"
      [colCountByScreen]="{ xs: 1, sm: 2 }"
      [elementAttr]="{ 'data-testid': 'profile-form-main' }"
    >
      <dxi-item
        dataField="phone"
        [editorOptions]="{
          mask: '(000) 000-0000',
          useMaskedValue: false,
          maskInvalidMessage: 'Enter a 10-digit US phone number',
          validationMessageMode: 'always',
          inputAttr: { 'data-testid': 'profile-input-phone' }
        }"
      >
        <!-- A mask error alone does not stop the submit; this rule does. Empty stays allowed. -->
        <dxi-validation-rule type="pattern" [pattern]="tenDigits" message="Enter a 10-digit US phone number"></dxi-validation-rule>
      </dxi-item>
      <!-- Read-only, so no validation rules: they only added a required star. -->
      <dxi-item dataField="email" [editorOptions]="{ disabled: true }"></dxi-item>
    </dx-form>

    <div class="password-row">
      <span class="password-label">Password</span>
      <!-- type="button": inside this form a plain button would submit and save. -->
      <button
        type="button"
        class="link-reset"
        (click)="openUpdatePasswordPopup()"
        data-testid="profile-link-change-password"
      >
        Change password
        <i class="dx-icon dx-icon-chevronright"></i>
      </button>
    </div>
  </section>

  <section *ngIf="features.emailSubscriptions" class="profile-section" data-testid="profile-card-subscriptions">
    <h5 class="section-heading">Email updates</h5>
    <app-subscribe-emails *ngIf="!loading" [userId]="profile?.data?.id"></app-subscribe-emails>
  </section>

  <div class="profile-actions">
    <dx-button
      [text]="saving ? 'Saving…' : 'Save changes'"
      [disabled]="saving"
      type="success"
      [useSubmitBehavior]="true"
      validationGroup="customerData"
      height="44px"
      [width]="160"
      [elementAttr]="{ 'data-testid': 'profile-btn-update' }"
    ></dx-button>
  </div>
</form>

<dx-popup
  [showTitle]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [width]="'min(400px, 95vw)'"
  [height]="'auto'"
  title="Update Your Password"
  [showCloseButton]="true"
  [(visible)]="isPasswordPopupOpen"
  (hiding)="closingPasswordPopup()"
  [elementAttr]="{ 'data-testid': 'profile-popup-password' }"
>
  <div class="p-4">
    <app-password-update></app-password-update>
  </div>
</dx-popup>
